import React from 'react';
import '../App.css';

export default function LoadTestMain() {
  return  <div className='services'><h1 className='homelabel'>Load Test Main Page</h1></div>;

 
}
